import KeyboardHideView from './keyboard_hide_view'

export default KeyboardHideView